
import { RemindersKeys } from '@/i18n/types/reminders.types';

export const reminders: Record<RemindersKeys, string> = {
  reminders: 'Recordatorios',
  reminder: 'Recordatorio',
  reminderTitle: 'Título',
  reminderDescription: 'Descripción',
  createReminder: 'Crear Recordatorio',
  editReminder: 'Editar Recordatorio',
  deleteReminder: 'Eliminar Recordatorio',
  cancelReminder: 'Cancelar Recordatorio',
  snoozeReminder: 'Posponer Recordatorio',
  reminderDateTime: 'Fecha y Hora',
  reminderRecurrence: 'Recurrentes',
  reminderTimezone: 'Zona Horaria',
  reminderChannels: 'Por Ubicación',
  reminderSnoozeInterval: 'Intervalo de Posposición',
  reminderStatus: 'Estado',
  reminderStatusPending: 'Pendientes',
  reminderStatusSent: 'Enviado',
  reminderStatusSnoozed: 'Pospuesto',
  reminderStatusCancelled: 'Cancelado',
  reminderSearch: 'Buscar recordatorios',
  reminderNoResults: 'No se encontraron recordatorios',
  reminderLoading: 'Cargando recordatorios...',
  reminderNotifications: 'Notificaciones',
  reminderManagement: 'Nunca olvides lo importante con recordatorios inteligentes y personalizados.',
  reminderCustomPatterns: 'Establece patrones de repetición',
  reminderCustomPatterns1: 'Notificaciones', 
  reminderMultipleChannels: 'Múltiples canales',
  reminderToday: 'Hoy',
  reminderWeek: 'Próximos 7 días',
  reminderAll: 'Todos',
  reminderSave: 'Guardar',
  reminderCancel: 'Cancelar',
  reminderCreated: 'Recordatorio creado exitosamente',
  reminderUpdated: 'Recordatorio actualizado exitosamente',
  reminderDeleted: 'Recordatorio eliminado exitosamente',
  reminderSnoozeFor: 'Posponer por',
  reminderMinutes: 'minutos',
  addReminder: 'Nuevo Recordatorio',
  filterByStatus: 'Filtrar por estado',
  allStatuses: 'Todos los estados',
  searchReminders: 'Buscar recordatorios...',
  noReminders: 'No hay recordatorios',
  noRemindersDesc: 'No se encontraron recordatorios para los filtros actuales.',
  loadingReminders: 'Cargando recordatorios...',
  confirmDeleteReminder: '¿Estás seguro de que deseas eliminar este recordatorio?',
};
